require('./hireCardImageSelector.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
const { connect } = require('react-redux');
// @ helpers
import { FormattedText } from 'core/i18n';
// @ actions
const hireCardImageSelectorActions = require('actions/hireCardImageSelector');
// @ commons
const { LoadingSection } = require('commonsComponents/loadingSection');

class HireCardImageSelector extends React.PureComponent {
    constructor(props) {
        super(props);

        this.selectCard = this.selectCard.bind(this);
    }

    UNSAFE_componentWillMount() {
        const { cardImageIds, immHireCardImageSelector, extraImage, getHireCardImages } = this.props;

        if (!immHireCardImageSelector.get('fetchSuccess')) {
            getHireCardImages(cardImageIds, extraImage);
        }
    }

    selectCard(id) {
        const { formActions } = this.props;
        formActions.change('userProfile.idHireCardSelected', id);
    }

    buildCardGrid() {
        const { hireCardImagesUpdateSelectedId, immHireCardImageSelector, extraImage } = this.props;
        const selectCard = this.selectCard;
        const primaryGridClassName = classNames('hire-card-image-selector__cell', 'col-sm-6', {
            'hire-card-image-selector__cell--extra': extraImage,
        });

        const iconClassName = classNames(
            'icons',
            'icons--icon-card-selected-red',
            'hire-card-image-selector__icon-selected',
            {
                'hire-card-image-selector__icon-selected--extra': extraImage,
            }
        );

        return immHireCardImageSelector.get('imagesByOrder').map((imageId, index) => {
            const immImage = immHireCardImageSelector.getIn(['imagesById', imageId]);
            const id = immImage.get('id');
            const url = immImage.get('url');
            const isSelected = id === immHireCardImageSelector.get('selectedImageId');
            const imageClassName = classNames('hire-card-image-selector__card-image', {
                [`hire-card-image-selector__card-image--extra`]: extraImage,
                'hire-card-image-selector__card-image--selected': isSelected,
            });
            let selectedIcon;
            let extraImageElement;
            let offset = 0;
            const gridClassName = classNames(primaryGridClassName, [`col-sm-offset-${offset}`]);

            if (isSelected) {
                selectedIcon = <i className={iconClassName} />;
            }

            if (extraImage) {
                const extraImageSrc = immHireCardImageSelector.getIn(['extraImageById', extraImage, 'url']);
                const extraImageClassName = `${imageClassName} hire-card-image-selector__extra-image`;

                extraImageElement = (
                    <div className="hire-card-image-selector__extra-image-container">
                        <img className={extraImageClassName} src={extraImageSrc} />
                    </div>
                );
            }

            return (
                <div className={gridClassName} key={index}>
                    <input
                        type="image"
                        className={imageClassName}
                        onClick={function () {
                            selectCard(id);
                            return hireCardImagesUpdateSelectedId(id);
                        }}
                        src={url}
                    />
                    {selectedIcon}
                    {extraImageElement}
                </div>
            );
        });
    }

    render() {
        const { immHireCardImageSelector } = this.props;
        let content;

        if (immHireCardImageSelector.get('isFetching')) {
            content = <LoadingSection />;
        } else {
            const { extraClass, extraImage } = this.props;
            const cards = this.buildCardGrid();
            let title = 'hireCardImageSelector-title';
            let subtitle;

            if (extraImage) {
                title = 'hireCardImageSelector-titleExtra';
                subtitle = (
                    <FormattedText
                        value="hireCardImageSelector-subtitle"
                        className="hire-card-image-selector__subtitle"
                    />
                );
            }

            content = (
                <article className="hire-card-image-selector">
                    <header className="hire-card-image-selector__header">
                        <h4 className="hire-card-image-selector__title">
                            <FormattedText value={title} />
                        </h4>
                    </header>
                    {subtitle}
                    <section className={`row hire-card-image-selector__section ${extraClass}`}>{cards}</section>
                </article>
            );
        }

        return content;
    }
}

HireCardImageSelector.propTypes = {
    cardImageIds: PropTypes.array.isRequired,
    extraClass: PropTypes.string,
    extraImage: PropTypes.string,
    getHireCardImages: PropTypes.func.isRequired,
    hireCardImagesUpdateSelectedId: PropTypes.func.isRequired,
    immHireCardImageSelector: PropTypes.object.isRequired,
};

HireCardImageSelector.defaultProps = {
    extraImage: '',
    extraClass: '',
    cardImageIds: ['B.506.011.001', 'B.506.011.002', 'B.506.011.003', 'B.506.011.004'],
};

module.exports.constructor = HireCardImageSelector;

module.exports.HireCardImageSelector = connect(
    state => ({
        immHireCardImageSelector: state.hireCardImageSelector,
        userProfile: state.userProfile,
    }),
    {
        getHireCardImages: hireCardImageSelectorActions.getHireCardImages,
        hireCardImagesUpdateSelectedId: hireCardImageSelectorActions.hireCardImagesUpdateSelectedId,
        reset: hireCardImageSelectorActions.reset,
    }
)(HireCardImageSelector);
